<template>
  <div>
    <v-row>
      <v-col>
        <v-text-field
          v-model="bookChapter.title"
          :label="$t('form.title')"
          required
          readonly
          filled
          outlined
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6">
        <v-text-field
          v-model="type"
          :label="$t('form.bookandchapter.type')"
          required
          readonly
          filled
          outlined
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="6">
        <v-text-field
          v-model="editorial.name"
          :label="$t('editorial')"
          required
          readonly
          filled
          outlined
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-text-field
          v-model="editors"
          :label="$t('form.editors')"
          required
          readonly
          filled
          outlined
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-text-field
          v-model="bookChapter.editors_text"
          :label="$t('form.bookandchapter.editors_text')"
          required
          readonly
          filled
          outlined
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="4">
        <v-text-field
          v-model="bookChapter.book_location.chapter"
          :label="$t('form.bookandchapter.chapter')"
          required
          readonly
          filled
          outlined
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="4">
        <v-text-field
          v-model="bookChapter.num_pages"
          :label="$t('form.bookandchapter.num_pages')"
          required
          readonly
          filled
          outlined
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="4">
        <v-text-field
          v-model="bookChapter.publication_date"
          :label="$t('form.bookandchapter.publication_date')"
          required
          readonly
          filled
          outlined
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="4">
        <v-text-field
          :value="bookChapter.book_location.page_number"
          :label="$t('form.bookandchapter.pageNumber')"
          required
          readonly
          filled
          outlined
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="4">
        <v-text-field
          v-model="bookChapter.book_location.page_start"
          :label="$t('form.bookandchapter.pageStart')"
          required
          readonly
          filled
          outlined
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="4">
        <v-text-field
          v-model="bookChapter.book_location.page_end"
          :label="$t('form.bookandchapter.pageEnd')"
          required
          readonly
          filled
          outlined
        ></v-text-field>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "DetailArticle",
  data: () => ({
    editors: "",
    type: "",
    editorial: "",
    persons: []
  }),
  props: {
    bookChapter: Object
  },
  created() {
    this.loadBookAndChapterType();
    this.loadEditorial();
    this.getPersons();
  },
  methods: {
    loadBookAndChapterType() {
      let path = this.$store.state.endpoint + "/utils/bookAndChapters";
      axios
        .get(path)
        .then(response => {
          response.data.forEach(item => {
            if (item === this.bookChapter.type) {
              this.type = this.$t("publication.bookAndChapter.types." + item);
            }
          });
        })
        .catch(error => {
          console.log(error);
        });
    },
    loadEditorial() {
      let path =
        this.$store.state.endpoint + "/editorial/" + this.bookChapter.editorial;
      axios
        .get(path)
        .then(response => {
          this.editorial = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    getPersons() {
      let path = this.$store.state.endpoint + "/person";
      axios
        .get(path)
        .then(response => {
          this.persons = response.data;
        })
        .finally(() => this.getNameEditors())
        .catch(error => {
          console.log(error);
        });
    },
    getNameEditors() {
      this.bookChapter.editors.forEach(editor => {
        const person = this.persons.find(person => person.id === editor);
        this.editors === ""
          ? (this.editors =
              person.preferred_name.given_name +
              " " +
              person.preferred_name.family_name)
          : (this.editors +=
              ", " +
              person.preferred_name.given_name +
              " " +
              person.preferred_name.family_name);
      });
    }
  }
};
</script>

<style scoped></style>
